import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
} from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';

interface CrewToolbarProps {
  onEventClick: (offsetNum: any) => void;
  offset: number;
  currentYear: string;
  week: number;
  onWeekChange: (weekNum: number) => void;
}
const CrewToolbar: React.FC<CrewToolbarProps> = ({
  onEventClick,
  offset,
  currentYear,
  week,
  onWeekChange,
}) => {
  const [currentOffset, setCurrentOffset] = useState<number>(offset);
  return (
    <Box
      sx={{
        background: 'rgba(0, 244, 255, 0.06)',
        height: '62px',
        marginTop: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '10px',
        paddingRight: '10px',
        border: '2px solid #EFEEED',
        borderTopLeftRadius: '14px',
        borderTopRightRadius: '14px',
      }}
    >
      <Box>
        <Typography variant="h6" sx={{ fontSize: '18px' }}>
          {currentYear}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          gap: '10px',
        }}
      >
        <Box>
          <FormControl
            fullWidth
            sx={{
              height: '43px',
              borderRadius: '12px',
            }}
          >
            <Select
              sx={{
                height: '40px',
                border: '2px solid #dddfe1 !important',
              }}
              id="weeks-select"
              value={week}
              label="Choose Week"
              onChange={(e: any) => {
                onWeekChange(e.target.value);
              }}
            >
              <MenuItem value={7}>1 Week</MenuItem>
              <MenuItem value={14}>2 Weeks</MenuItem>
              <MenuItem value={21}>3 Weeks</MenuItem>
              <MenuItem value={30}>4 Weeks</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box>
          <IconButton
            type="button"
            sx={{
              background: '#fff',
              border: '1px solid #b6b6b6;',
              height: '35px',
              width: '35px',
              paddingRight: '0px',
            }}
            onClick={() => {
              onEventClick(currentOffset - 1);
              setCurrentOffset(currentOffset - 1);
            }}
          >
            <ArrowBackIos sx={{ height: '22px', width: '22px' }} />
          </IconButton>
          <Button
            onClick={() => {
              setCurrentOffset(0);
              onEventClick(0);
            }}
            sx={{
              background: '#fff',
              border: '1px solid #b6b6b6',
              padding: '6px 16px',
              borderRadius: '25px',
            }}
          >
            Today
          </Button>
          <IconButton
            type="button"
            sx={{
              background: '#fff',
              border: '1px solid #b6b6b6;',
              height: '35px',
              width: '35px',
            }}
            onClick={() => {
              onEventClick(currentOffset + 1);
              setCurrentOffset(currentOffset + 1);
            }}
          >
            <ArrowForwardIos sx={{ height: '22px', width: '22px' }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default CrewToolbar;
